import { useEffect } from "react";
import "../css/docs.css";
import { Link } from "react-router-dom";
import { CreateCode } from "./reference";
import { ScrollToHash } from "./home";
import Head from "./head";

var data = [
   {
      title: "script",
      content: `
//Call the script preferably in the (head) tag of your project.
&lt;script src="merlindb.min.js">&lt;/script> //42,7 kB 
      `
   },
   {
      title: "npm",
      content: `
npm install @chrisaxxwell/merlin-db;
import MerlinDB, {Schema} from "@chrisaxxwell/merlin-db";
      `
   },
   {
      title: "new",
      content: `
const merlin = new MerlinDB();
      `
   },
   {
      title: "connect",
      content: `
merlin.connect(<YOUR-DATABASE-NAME>);
      `
   },
   {
      title: "schama",
      content: `
var usersSchema = Schema({
   email: {
      type: String, 
      unique: true
   },
   name: { type: [ String ], required: true },
   age: [ Number, String ],
   city: String,
});
      `
   },
   {
      title: "model",
      content: ` 
const Users = merlin.model('Users', usersSchema);
      `
   },
   {
      title: "crud",
      content: `
//Insert 
Users.insert({ name: "Chris", age: 27 }).then(e=> console.log(e));

//Find
Users.find({ age: 27 }).then(e=> console.log(e));

//Update
Users.updateOne({ 
   //Every name = Sophie
   name: { $regex: ["Sophie", "i"] } }, 
   { $set: { name: "Lady Sophie" } 
});

//Delete
Users.deleteOne({ name: "Chris" }).then(e=> console.log(e));
      `
   },
]

function Access({ data }) {

   return (
      <div className="access">
         {data.map((e, i) => (
            e.link !== void 0 ?
               <Link key={i} className={!e.accessible ? "in" : null} to={e.link}>{e.text}</Link> :
               e.href !== void 0 ? <a href={e.href} key={i} className={!e.accessible ? "in" : null}>{e.text}</a> : null
         ))}
      </div>
   )
}

export default function Docs() {
   ScrollToHash();

   useEffect(() => {
      if (window.location.hash === '') {

         window.scrollTo(0, 0);
      }
   }, []);

   return (
      <main id="docs">
         <Head props={{
            site_name: "MerlinDB",
            page_type: "website",
            title: "Docs - MerlinDB",
            description: "Making it easier to store data in the browser com MerlinDB Database.",
            page_author: "Chris Axxwell",
            index: "index, follow",
            keywords: "Database, database, MerlinDB, IndexedDB, Banco de dados",
            canonical: "/docs",
            lang: "en_US",
            theme_color: "#250649",
            img_page: "/merlindb-poster.jpg", //imagem que ta dentro de src/files/images/head/
            img_alt: "MerlinDB poster",
            twitter_username_creator: "chrisaxxwell",
            twitter_username: "chrisaxxwell",
            icon: "/merlin-logo.svg", //o icone da pagina em /src/files/
            noCache: false, //adicone true, em paginas de usuario e paginas que nao quer adiionar no cache, se for true entao noa adicionapaginas no cache tipo para paginas de usuario, paginas de blogs atualizados e tals
            //redirect: ["https://www.chrisaxxwell.com", 3], //redireciona a pagina para outra pagina ou outro dominio depois de 3 segundos ou nao defina para 0
         }} />
         <Access data={[
            {
               link: "/", text: "Home", accessible: true
            },
            {
               link: "#", text: "Docs", accessible: false
            },
            { href: "#introduction", text: "Introduction", accessible: true },
            { href: "#getting-start", text: "Getting Start", accessible: true },
         ]} />

         <h1>GET STARTED WITH THE MERLINDB <li data-disappear="Hocus Pocus"></li></h1>
         <h2>Making it easier <li data-disappear=" (can you see me) "></li> to store data in the browser.</h2>

         <h3 id="introduction" className="landing-scroll">Introduction</h3>
         <h4>MerlinDB <li data-disappear-2="me, me, me haha"></li> is a database based on <strong>IndexedDB</strong>, a web browser storage API that allows developers to create complex applications that can store <strong>large amounts of data</strong>. Unlike local storage and cookies, IndexedDB stores data in a structured way, allowing for advanced queries and transactions. It supports storage of different types of data, including <strong>binary</strong> files, and works <strong>asynchronously</strong>, ensuring that read and write operations do not block the user interface. With IndexedDB, you can create web applications that work <strong>offline</strong> and offer robust performance, similar to traditional databases.</h4>
         <br></br>
         <br></br>
         <h4>Knowing this, I decided to create an efficient and familiar way for developers working with MongoDB and Mongoose. Getting to grips with IndexedDB can sometimes seem challenging and tiring, so this tool is a way to bring your MongoDB skills to IndexedDB. Have fun with the process and mahalo!</h4>

         <span></span>
         <h3 id="getting-start" className="landing-scroll">Getting started</h3>
         <Access data={[
            { href: "#", text: "docs", accessible: true },
            { href: "#introduction", text: "Introduction", accessible: true },
            { href: "#getting-start", text: "Getting Start", accessible: false },
            { link: "../guides", text: "Guides", accessible: true },
         ]} />
         <h4>Working with <strong>MerlinDB</strong> is as simple as taking candy from a child, by the way, never take candy from a child!!!. Besides, why would you do that? 🍭.</h4>
         <h5>1*: Download the <strong>merlindb.min.js</strong> right <Link to='/download'>here</Link> or:</h5>

         <h5>2 (script)*: Insert the script into your project, like this:</h5>
         <code >
            <CreateCode content={data[ 0 ].content} />
         </code>
         <h5>2 (npm)*:  Or try npm:</h5>
         <code >
            <CreateCode content={data[ 1 ].content} />
         </code>
         <h5>3*: Call the <strong className="schema2">new</strong> MerlinDB():</h5>
         <code >
            <CreateCode content={data[ 2 ].content} />
         </code>
         <h5>4*: Connect to database:</h5>
         <code >
            <CreateCode content={data[ 3 ].content} />
         </code>
         <h5>5*: Create an <strong>Schema</strong>:</h5>
         <code >
            <CreateCode content={data[ 4 ].content} />
         </code>
         <h5>6*: Initialize your <strong>new model</strong>:</h5>
         <code >
            <CreateCode content={data[ 5 ].content} />
         </code>
         <h5 id="crud" className="landing-scroll">7*: <strong className="schema3">CRUD</strong> (Insert, Update and Remove):</h5>
         <code >
            <CreateCode content={data[ 6 ].content} />
         </code>
         <span></span>
         <h3>Congratulations</h3>
         <Access data={[
            { href: "#introduction", text: "Introduction", accessible: true },
            { href: "#getting-start", text: "Getting Start", accessible: true },
            { href: "", text: "Congrats", accessible: false },
            { link: "../guides", text: "Guides", accessible: true },
         ]} />
         <h4>You have completed our quickstart, we have started our database, created a schema for validations and commits, started our model, inserted, updated, found and removed data, for our complete guide go <Link to="../guides">guides</Link>. See our documentation on github if you want <a href="https://github.com/chrisaxxwell/merlin-db" target="_blank" rel="noreferrer">GuitHub Docs</a>.</h4>
      </main >
   )
}

export { Access }